// window.initItems (listing_page/tracking.js and the CollectionHub tracker) rebuilds the list of
// trackable items by parsing the tracking JSON of every card on the page. Each card asks for it as
// it comes into view, so a 120-card grid parsed all 120 cards for every card that scrolled in.
// The list only changes when the cards' tracking data or the page config does, so rebuild then.
let lastNodes = []
let lastAttributes = []
let lastPageConfig = null

function hasSameItems(nodes) {
  if (nodes.length === 0 || nodes.length !== lastNodes.length || window.pageConfig !== lastPageConfig) {
    return false
  }

  for (let i = 0; i < nodes.length; i += 1) {
    if (nodes[i] !== lastNodes[i] || nodes[i].getAttribute('data-attributes') !== lastAttributes[i]) {
      return false
    }
  }

  return true
}

export default function initTrackableItems() {
  if (typeof window === 'undefined' || typeof window.initItems !== 'function') {
    return
  }

  const nodes = Array.from(document.querySelectorAll('.js-fast-listing-item'))

  if (hasSameItems(nodes)) {
    return
  }

  lastNodes = nodes
  lastAttributes = nodes.map((node) => node.getAttribute('data-attributes'))
  lastPageConfig = window.pageConfig
  window.initItems()
}

// Test-only: the cache is module-level and would otherwise leak between specs.
export function resetTrackableItemsCache() {
  lastNodes = []
  lastAttributes = []
  lastPageConfig = null
}
